import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { auditKeys } from "./query-keys";

/**
 * GET /v1/audit-events/{event_id} — single event detail, driving the ledger
 * drawer. `eventId` is Task 1's `AuditFilterState.event_id` (URL-only drawer
 * state); passing `undefined` (drawer closed) disables the query entirely —
 * no request is made.
 */
export function useAuditEvent(eventId: number | undefined) {
  return useQuery({
    queryKey: auditKeys.detail(eventId ?? -1),
    enabled: eventId !== undefined,
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/audit-events/{event_id}", {
        params: { path: { event_id: eventId as number } },
      });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
  });
}
